import styled from 'styled-components';
import { motion } from 'framer-motion';

  export const Overlay = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  `;

  export const CloseButton = styled.button`
    position: absolute;
    top: 1rem;
    right: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 38px;
    border: 2px solid white;
    border-radius: 7px;
    background: transparent;
    background-color: ${({ theme }) => theme.bgColor};
    color: ${({ theme }) => theme.textColor};
    font-size: 1.25rem;
    cursor: pointer;
    z-index: 10000;

    opacity: 0; /* Hide button initially */
    transition: opacity 0.3s ease-in-out; /* Smooth fade-in effect */
  `;

  /** The floating bar for zoom & fullscreen buttons. */
  export const ControlBar = styled.div`
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10000;
    display: flex;
    gap: 0.75rem;
    `;

  /** Individual control buttons for zoom + fullscreen. */
  export const ControlButton = styled.button`
    width: 38px;
    height: 38px;
    border: 2px solid white;
    border-radius: 7px;
    background: transparent;
    background-color: ${({ theme }) => theme.bgColor};
    color: ${({ theme }) => theme.textColor};
    font-size: 1.25rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    opacity: 0; /* Hide button initially */
    transition: opacity 0.3s ease-in-out; /* Smooth fade-in effect */
    `;

  export const ModalContainer = styled.div`
    position: relative;
    width: 70vw;
    height: 70vh;
    max-width: 900px;
    aspect-ratio: 16 / 9;
    border-radius: 15px;
    background: #000;
    overflow: hidden;

    &:hover ${CloseButton} {
    opacity: 1;
    }

    &:hover ${ControlButton} {
    opacity: 1;
    }
  `;

  /** Loading/Error status overlay for video player */
  export const PlayerStatus = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    color: #fff;
    font-size: 1.1rem;
    z-index: 5;
  `;

  export const RetryButton = styled.button`
    margin-top: 0.5rem;
    padding: 8px 24px;
    border: 2px solid #33ff99;
    border-radius: 8px;
    background: transparent;
    color: #33ff99;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #33ff99;
      color: #000;
    }
  `;

  /** Container to apply transform: scale(...) for zooming. */
  export const ImageContainer = styled.div`
    width: 100%;
    height: 100%;
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease-in-out;
  `;

